import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import DestructiveButton from '../controls/DestructiveButton';
import { useForceUpdate, numberToLetter, getRawText } from '../util';
import { Content, Component } from '../DataStructures';
import { TabContextProvider, TabContextReporter } from '../TabContext';
function TreeBranches({
  index,
  data,
  forceUpdate,
  openDataModal,
  triggerStateUpdate,
  scopeToItem,
  ...props
}) {
  const dataProps = data.props;
  return /*#__PURE__*/React.createElement("div", null, dataProps.paths.map((path, i) => {
    const letter = numberToLetter(i);
    //return <TreeBranches index={index + "." + i} title={getRawText(path.buttonProps.children)}/>
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement(TabContextReporter, {
      index: index + "." + i,
      title: index + "." + i + ". " + getRawText(path.buttonProps.children)
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, "Path ", letter, " button text")), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove path",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        dataProps.paths.splice(i, 1);
        triggerStateUpdate();
      }
    }))), /*#__PURE__*/React.createElement(RichText, {
      inlineOnly: true,
      value: path.buttonProps.children,
      onChange: v => {
        path.buttonProps.children = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "secondary",
      onClick: () => {
        openDataModal(data, ["props", "paths", i, "buttonProps"]);
      }
    }, "Edit button ", letter, " props"), /*#__PURE__*/React.createElement(Form.Label, null, "Path ", letter, " content"), /*#__PURE__*/React.createElement(RichText, {
      value: path.content[0].children,
      onChange: v => {
        path.content[0].children = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      onClick: () => {
        // Only have a single tree in the path. It's simpler this way.
        openDataModal(data, ["props", "paths", i, "content", 0]);
      }
    }, "Edit path ", letter))), /*#__PURE__*/React.createElement(TreeBranches, {
      index: index + "." + i,
      data: path.content[0],
      forceUpdate: forceUpdate,
      openDataModal: openDataModal,
      triggerStateUpdate: triggerStateUpdate,
      scopeToItem: scopeToItem
    }));
  }));
}
export default function TaskTree(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "0. Root"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Tree content"), /*#__PURE__*/React.createElement(RichText, {
    value: props.data.children,
    onChange: v => {
      props.data.children = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Button, {
    block: true,
    variant: "primary",
    onClick: () => {
      let fullPath = props.path.slice();
      fullPath.push("children");
      props.scopeToItem(fullPath);
      props.triggerStateUpdate();
      props.onChanged();
    }
  }, "Scope To Item")), /*#__PURE__*/React.createElement(TreeBranches, {
    index: "0",
    data: props.data,
    openDataModal: props.openDataModal,
    forceUpdate: forceUpdate,
    triggerStateUpdate: props.triggerStateUpdate,
    scopeToItem: props.scopeToItem,
    onChanged: props.onChanged
  }), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "0. Root"
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    variant: "success",
    onClick: () => {
      const letter = numberToLetter(dataProps.paths.length);
      dataProps.paths.push({
        buttonProps: {
          tagName: "Button",
          children: `Path ${letter}`
        },
        content: new Content(new Component({
          tagName: "TaskTree",
          children: new Content(`Path ${letter} text`),
          props: {
            paths: []
          }
        }))
      });
      props.triggerStateUpdate();
      props.onChanged();
    }
  }, "Add New Path")));
}